/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionLeagueRead
 */
export interface CompetitionLeagueRead {
    /**
     * 
     * @type {string}
     * @memberof CompetitionLeagueRead
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof CompetitionLeagueRead
     */
    created_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof CompetitionLeagueRead
     */
    id: string;
}

/**
 * Check if a given object implements the CompetitionLeagueRead interface.
 */
export function instanceOfCompetitionLeagueRead(value: object): value is CompetitionLeagueRead {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CompetitionLeagueReadFromJSON(json: any): CompetitionLeagueRead {
    return CompetitionLeagueReadFromJSONTyped(json, false);
}

export function CompetitionLeagueReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionLeagueRead {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'id': json['id'],
    };
}

export function CompetitionLeagueReadToJSON(json: any): CompetitionLeagueRead {
    return CompetitionLeagueReadToJSONTyped(json, false);
}

export function CompetitionLeagueReadToJSONTyped(value?: CompetitionLeagueRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'id': value['id'],
    };
}

